module.exports = __webpack_public_path__ + "img/Swimming.32197bca.png";